<template>
  <div class="caseheader-layer">
    <div class="content-top" v-if="isCJTY == 0">
      <div class="top-left">{{ casename }}</div>
      <div class="top-right">
        <div class="l-btn-3" @click="onBackDYGPT" v-show="$route.path == '/case/touyanbaogao'">返回DYGPT</div>
        <div class="r-btn-jiaojuan" @click="onNextStep" style="margin-right: 20px;"
             v-if="step == 0 && $route.path == '/case/shangwushuju'">下一步</div>
        <div class="r-btn-miaoshu" @click="openCaseDesc">案例描述</div>
        <div class="r-btn-jiaojuan" @click="onSubmitPaper">交卷</div>
      </div>
    </div>
    <!--案例描述-->
    <casedescDialog ref="casedescDialog" :describtion="describtion" :casetype="casetype"></casedescDialog>
  </div>
</template>

<script>
import apiUser from "@/api/user";
import casedescDialog from '../casedescDialog.vue'
export default {
  name: '',
  components: { casedescDialog },
  props: {},
  data () {
    return {
      isCJTY: 0,
      casename: '',
      describtion: '',
      casetype: 1,
      step: 0
    }
  },
  computed: {},
  watch: {},
  created () {
    this.isCJTY = sessionStorage.getItem('isCJTY') || 0
    this.casename = sessionStorage.getItem('casename')
    this.describtion = sessionStorage.getItem('describtion')
    this.casetype = sessionStorage.getItem('casetype')
  },
  mounted () { },
  methods: {
    // 下一步
    onNextStep () {
      this.$emit('nextStep', 1)
    },
    onBackDYGPT () {
      //这里是AI场景的返回
      this.$router.push({ path: '/case/dygpt', query: { type: sessionStorage.getItem('casetype'), caseno: sessionStorage.getItem('caseno'), routename: 'touyanbaogao', extend: '' } })
    },
    // 打开案例描述
    openCaseDesc () {
      this.$refs['casedescDialog'].show()
    },
    onSubmitPaper () {
      this.$confirm('点击确认将交卷', '提示').then(() => {
        // 调用 交卷接口
        let dygptaccount
        let type = sessionStorage.getItem('casetype')
        if (type == 1) {
          dygptaccount = sessionStorage.getItem('dygptaccount') + '_AL'
        } else if (type == 2) {
          dygptaccount = sessionStorage.getItem('dygptaccount') + '_GZL'
        } else {
          dygptaccount = sessionStorage.getItem('dygptaccount')
        }
        let userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
        apiUser.CaseSubmit({
          caseId: sessionStorage.getItem('caseno'),
          studentUsername: dygptaccount,
          userId: userInfo.f_Id,
          mode: type == 1 ? 2 : 1,// 接口中类型标识：1=工作流案例，2=场景类型
        }
        ).then((res) => {
          console.log(res);
          if (res) {
            // this.$message({ type: res.code == 200 ? 'success' : 'warning', message: res.message })
            console.log("res>>>", res);
          }
        });
        setTimeout(() => {
          this.$router.replace({
            path: '/case/caseselect'
          })
          // 清除API秘钥缓存
          sessionStorage.removeItem('xlznt_jf_key')
          sessionStorage.removeItem('xlznt_tw_key')
          sessionStorage.removeItem('znkf_key')
        }, 500);
        // this.$router.replace({
        //   path: '/case/caseselect'
        // })
        // // 清除API秘钥缓存
        // sessionStorage.removeItem('xlznt_jf_key')
        // sessionStorage.removeItem('xlznt_tw_key')
        // sessionStorage.removeItem('znkf_key')
      })
    },
  }
}
</script>

<style scoped lang="less">
.caseheader-layer {
  .content-top {
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 40px;
    user-select: none;

    .top-left {
      min-width: 400px;
      max-width: calc(100% - 400px);
      height: 38px;
      line-height: 38px;
      font-size: 16px;
      color: #fff;
      font-weight: bold;
      background: linear-gradient(to right, #235df05e, #1ccaff42, transparent);
      position: relative;
      top: 3px;
      left: -20px;
      padding-right: 50px;

      &::before {
        content: "";
        display: inline-block;
        width: 4px;
        height: 100%;
        background-color: #0a6cdd;
        vertical-align: top;
        margin-right: 15px;
        border-radius: 5px 0 0 5px;
      }
    }

    .top-right {
      display: flex;

      .l-btn-3 {
        width: 139px;
        height: 40px;
        line-height: 40px;
        background: #fff;
        border-radius: 9px;
        color: #666666;
        font-weight: bold;
        text-align: center;
        cursor: pointer;
        margin-right: 20px;
      }

      .r-btn-miaoshu,
      .r-btn-jiaojuan {
        width: 139px;
        height: 40px;
        line-height: 40px;
        cursor: pointer;
        text-align: center;
        font-weight: bold;
        color: #fff;
        border-radius: 9px;
        box-shadow: 0 0 5px -1px rgba(255, 255, 255, 0.6) inset;

        &:hover {
          filter: hue-rotate(20deg) brightness(100%);
          box-shadow: 0 0 10px -1px rgba(255, 255, 255, 0.6) inset;
        }
      }

      .r-btn-miaoshu {
        background: rgba(255, 255, 255, 0.3);
        margin-right: 20px;
      }

      .r-btn-jiaojuan {
        background: linear-gradient(90deg, #76E8FE 0%, #2187EC 100%);
      }
    }
  }
}
</style>
